import styled from 'styled-components'
import {Link} from 'react-router'
import {spacing} from '../../../../../theme/spacing'

export const LeftContainerStyle = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: ${spacing(3)};
    justify-content: flex-start;
`

export const LogoStyle = styled(Link)`
    display: block;
    width: 214px;
    height: 46px;
    margin-right: ${spacing(10)};
`
